module.exports = __webpack_public_path__ + "img/pillar_grey.042311f7.png";